import dayjs from 'dayjs';

import { Announcement } from '@/graphql';

export const isAnnouncementCurrentlyActive = (announcement: Announcement) =>
  announcement.isActive &&
  (dayjs(announcement.from).isBefore(new Date()) || !announcement.from) &&
  (dayjs(announcement.to).isAfter(new Date()) || !announcement.to);

export const isUserFeedbackCurrentlyActive = (announcement: Announcement) =>
  announcement.isUserFeedbackActive &&
  (dayjs(announcement.from).isBefore(new Date()) || !announcement.from) &&
  (dayjs(announcement.to).isAfter(new Date()) || !announcement.to);
